<script>
import View from '@/views/View'

export default {
  name: 'meagan',
  metaInfo: { title: 'Manual onboarding' },
  extends: View,
  components: {
    componentFooter: () => import('./sections/Footer.vue'),
    componentGetStartedSection: () => import('./sections/GetStartedSection.vue'),
    componentHeader: () => import('./sections/Header.vue'),
    componentInvitationPreviewSection: () => import('./sections/InvitationPreviewSection.vue')
  }
}
</script>

<template>
  <div>
    <componentHeader />
    <componentInvitationPreviewSection />
    <componentGetStartedSection />
    <componentFooter />
  </div>
</template>
